'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clipboard = require('clipboard');

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  bindListeners: function bindListeners() {
    $(document).ready(function () {
      new _clipboard2.default('#swell-copy-clipboard-btn');
      var e = void 0;
      var FADE_SPEED = 500;

      $(document).on('click', '.back-link', function (event) {
        event.preventDefault();
        $('.referral-copy, .referral-thanks').fadeOut(FADE_SPEED, function () {
          $(this).remove();
        });
        setTimeout(function () {
          $(e).hide().appendTo('.referral-container').fadeIn(FADE_SPEED);
          SwellMVMT.mvmtRefreshEmbeds();
        }, FADE_SPEED);
      });

      $(document).on('click', '.back-link', function (event) {
        event.preventDefault();
        $('.referral-copy, .referral-thanks').fadeOut(FADE_SPEED, function () {
          $(this).remove();
        });
        setTimeout(function () {
          $(e).hide().appendTo('.referral-container').fadeIn(FADE_SPEED);
          SwellMVMT.mvmtRefreshEmbeds();
        }, FADE_SPEED);
      });

      $(document).on('click', '.swell-copy-link', function (event) {
        event.preventDefault();
        e = $('.referral-registered');
        $('.referral-registered').fadeOut(FADE_SPEED, function () {
          $(this).remove();
        });
        setTimeout(function () {
          $(referral_copy).hide().appendTo('.referral-container').fadeIn(FADE_SPEED);
          $('body').scrollTop($('.back-link').offset().top - parseInt($('main').css('margin-top')) - parseInt($('.referral-content-container').css('padding-top')));
          SwellMVMT.mvmtRefreshEmbeds();
        }, FADE_SPEED);
      });

      $(document).on('submit', '#refer-form', function (event) {
        event.preventDefault();
        var t = $('#referrer-email-list');
        var artistTrack = t.val().split(',');

        t.removeClass('error');
        swellAPI.sendReferralEmails(artistTrack, function () {
          e = $('.referral-registered');
          $('.referral-registered').fadeOut(FADE_SPEED, function () {
            $(this).remove();
          });
          setTimeout(function () {
            $(referral_thanks).show().appendTo('.referral-container').fadeIn(FADE_SPEED);
            $('body').scrollTop($('.back-link').offset().top - parseInt($('main').css('margin-top')) - parseInt($('.referral-content-container').css('padding-top')));
            SwellMVMT.mvmtRefreshEmbeds();
          }, FADE_SPEED);
        }, function () {
          $('.referral-section').prepend('<p class="referral-error">Error, this email address is already associated with an existing customer, your referral is not valid.</p>');
          t.addClass('error');
          t.focus();
        });
      });

      $(document).on('submit', '.referral-register-form', function (event) {
        event.preventDefault();
        var n = $('.referral-register-form #referral-email');
        var artistTrack = n.val();

        swellAPI.identifyReferrer(artistTrack, function () {
          $('.referral-new').fadeOut(FADE_SPEED, function () {
            $(this).remove();
          });
          setTimeout(function () {
            $(referral_registered).hide().appendTo('.referral-container');
            $('.referral-registered-container').prepend(referral_registered_new);
            $('.referral-registered').fadeIn(FADE_SPEED);
            SwellMVMT.mvmtRefreshEmbeds();
          }, FADE_SPEED);
        }, function () {
          n.addClass('error');
        });
      });
    });

    $(document).on('swell:setup', function () {
      var obj = swellAPI.getCustomerDetails();
      var r = $('.referral-container');

      if (r.length === 1) {
        var n = obj.email && obj.email != '' ? referral_registered : referral_new;

        r.append(n);
      }
      if (obj.pointsBalance > 0) {
        $('#header-credit').html('<span style="font-weight: bold;" class="swell-mvmt-credits"></span>&nbsp;PTS');
      }
      SwellMVMT.mvmtRefreshEmbeds();
      SwellMVMT.renderRewardTitle();
      SwellOverwrite.addReferralCodeToModal();
    });
  },
  init: function init() {
    this.bindListeners();
  }
};